
import styles from "./style.module.scss";

type SecureHTMLRenderProps = {
  htmlBody?: string
  /** Cuando es true, el contenido se muestra escapado y respetando saltos de línea. */
  isPlainText?: boolean
};

const escapeHtml = (value: string): string =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const SecureHTMLRender = (props: SecureHTMLRenderProps) => {
  const { htmlBody, isPlainText = false } = props

  const srcDoc = isPlainText && htmlBody
    ? `<pre style="white-space:pre-wrap;word-break:break-word;font-family:inherit;margin:0">${escapeHtml(htmlBody)}</pre>`
    : htmlBody

  return (
    <>
      <iframe
        className={styles.iframe}
        sandbox="allow-popups allow-popups-to-escape-sandbox"
        srcDoc={srcDoc}
        data-testid="secure-html-render"
      />
    </>
  );
}

export default SecureHTMLRender;
